module.exports = __webpack_public_path__ + "static/media/dsr_finance1.d79a5dc7.svg";